import React, { useEffect, useState } from 'react'
import { FaPrint } from 'react-icons/fa'
import { useNavigate, useLocation } from 'react-router-dom';
import Config from '../Header/Config';
import converter from 'number-to-words';
export default function Purchase_invoice() {

  const [name, setName] = useState('');
  const [date, setDate] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [grandTotal, setGrandTotal] = useState('');
  const [discount, setDiscount] = useState('');
  const [subTotal, setSubTotal] = useState('');
  const [invoice, setInvoice] = useState('');
  const [loading, setLoading] = useState(true);
  const [tabledata, setTableData] = useState([]);
  const apiUrl = Config.apiUrl;

  //................................{ set data in invoice }...............................
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const invoice_Number = searchParams.get('invoice_no');


  //......................{ fetch brand details }.......................

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_purchaseInvoice/${invoice_Number}`);
        const data = await response.json();

        // API already returns data filtered by invoice_no, so use data.data directly
        const purchaseData = data.data || [];
        
        // Additional safety check - filter if needed
        const filterData = purchaseData.filter((item) => item.invoice_no === invoice_Number);
        console.log("Purchase Invoice Data:", filterData);

        if (filterData && filterData.length > 0) {
          setTableData(filterData);

          setName(filterData[0].supplier_name || '');
          setDate(filterData[0].date || '');
          setMobileNumber(filterData[0].mobile_no || '');
          setGrandTotal(filterData[0].grand_total || '0');
          setDiscount(filterData[0].discount || '0');
          setSubTotal(filterData[0].sub_total || '0');
          setInvoice(filterData[0].invoice_no || '');
        } else {
          console.error("No data found for invoice:", invoice_Number);
          setTableData([]);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching purchase invoice:", error);
        setLoading(false);
      }
    };

    if (invoice_Number) {
      fetchData();
    }
  }, [invoice_Number, apiUrl]);

  //......................{ after print Hide buttons }.....................

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const [showDiv, setShowDiv] = useState(true);

  const handlePrint = () => {
    if (loading || !tabledata || tabledata.length === 0) {
      alert("Please wait for data to load before printing.");
      return;
    }
    setShowDiv(false);
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        setShowDiv(true);
      }, 100);
    }, 100);
  };

  useEffect(() => {
    const handleBeforePrint = () => {
      setShowDiv(false);
    };

    const handleAfterPrint = () => {
      setShowDiv(true);
    };

    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);

  // Assuming grandTotal is a string representation of a number
  const parsedGrandTotal = parseFloat(subTotal); // or parseInt(grandTotal, 10) if it's an integer


  return (
    <>
      <style>
        {`
          @media print {
            @page {
              size: A4;
              margin: 10mm;
            }
            * {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            body {
              margin: 0;
              padding: 0;
            }
            .no-print {
              display: none !important;
            }
            section {
              margin: 0;
              padding: 0;
              page-break-before: avoid;
            }
            .invoice-boxx {
              page-break-before: avoid;
              page-break-after: avoid;
            }
            .invoice-header {
              page-break-after: avoid;
            }
            table {
              page-break-inside: avoid;
            }
            tr {
              page-break-inside: avoid;
            }
            thead {
              display: table-header-group;
            }
            tfoot {
              display: table-footer-group;
            }
            tbody tr:last-child {
              page-break-after: auto;
            }
            .print-section {
              margin: 0 !important;
              padding: 0 !important;
            }
            .print-container {
              padding: 0 !important;
              margin: 0 !important;
            }
            .print-content {
              padding: 0 !important;
              margin: 0 !important;
            }
            .invoice-boxx {
              margin: 0 !important;
              padding: 0 !important;
            }
          }
          .tables {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dddddd;
          }
          .tables th,
          .tables td {
            border: 1px solid #dddddd;
            padding: 8px;
            word-wrap: break-word;
          }
          .tables th {
            background-color: #f5f5f5;
            font-weight: bold;
          }
          .invoice-boxx {
            width: 100%;
            height: auto;
            min-height: auto;
          }
          .invoice-header {
            width: 100%;
            height: auto;
          }
        `}
      </style>
      <section style={{ backgroundColor: "white", minHeight: "100vh", height: "auto" }} className="print-section">
        <div style={{ padding: "20px", height: "auto" }} className="print-container">
          <div style={{ margin: 'auto', padding: '30px 24%', position: 'relative', maxWidth: "210mm", height: "auto" }} className="print-content">
            {showDiv && (
              <>
                <div className="no-print" style={{ margin: "auto", padding: "30px 0px", position: "relative", maxWidth: "210mm" }}>
                  <div style={{ float: "left" }}>
                    <button className='btn btn-outline-primary' onClick={handleBack}>Back</button>
                  </div>
                  <div style={{ float: "right" }}>
                    <button className='btn btn-outline-danger' onClick={handlePrint}><FaPrint className="icon_color" /></button>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="invoice-boxx">
            <div className="invoice-header" style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', top: '0', right: '0', fontSize: '12px', fontWeight: 'bold', padding: '5px' }}>
                GST No: 27DEJPG8013K1ZB
              </div>
              <table>
                <tbody>
                  <tr>
                    <td style={{ border: "1px solid #dddddd", width: "50%" }}>

                      <b>Name : {name}</b>
                      <br />

                      <b> Mobile No: {mobileNumber}</b>

                      <br />
                    </td>
                    <td style={{ border: "1px solid #dddddd", width: "50%" }}>

                      <b>Date : {date}</b>
                      <br />
                      <b>Invoice No: {invoice}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr style={{ border: "1px solid #dddddd", width: "50%" }}>
                    {/* <p
                  className="text-center"
                  style={{
                    marginTop: "10px",
                    marginBottom: "10px",
                    fontSize: "35px",
                    padding: "0px 10px",
                    lineHeight: "1.1"
                  }}
                > */}
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

                      <div style={{ width: "100%" }}> <center><h1 className='mt-3' style={{ color: "#555", fontSize: "40px" }} ><b>Mobile City</b> </h1> </center>
                        <center><h5 style={{ fontSize: "12px" }}><b>Secound hand mobiles & Accessories</b></h5></center></div>
                    </div>
                    {/* </p> */}
                    <td style={{ width: "50%", border: "1px solid #dddddd" }}>
                      <p style={{ lineHeight: " 1.2" }}>
                        <b>Baburao</b>
                        <br />
                        <span className="fw-200">
                          Docotors Colony, near Tejam Hospital, Gadhinglaj, Dist- Kolhapur Pin- 416 502
                        </span>{" "}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
            <div style={{ width: "100%", overflowX: "auto", overflowY: "visible", marginTop: "10px", minHeight: "auto" }}>
              <table className="tables" style={{ width: "100%", borderCollapse: "collapse", height: "auto" }}>
                <thead>
                  <tr>
                    <th style={{ width: "5%", minWidth: "40px" }}>Sr No</th>
                    <th style={{ width: "35%", minWidth: "150px" }}>Product</th>
                    <th style={{ width: "25%", minWidth: "120px" }}>IMEI</th>
                    <th style={{ width: "10%", minWidth: "60px", textAlign: "center" }}>Quantity</th>
                    <th style={{ width: "15%", minWidth: "80px", textAlign: "right" }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" style={{ padding: "20px", textAlign: "center" }}>
                        Loading...
                      </td>
                    </tr>
                  ) : Array.isArray(tabledata) && tabledata.length > 0 ? (
                    tabledata.map((row, index) => (
                      <tr key={index}>
                        <td style={{ textAlign: "center" }}>{index + 1}</td>
                        <td>{row.model_name || '-'}</td>
                        <td style={{ wordBreak: "break-all" }}>{row.imei || '-'}</td>
                        <td style={{ textAlign: "center" }}>1</td>
                        <td style={{ textAlign: "right" }}>
                          &#8377;{row.purchase_price || '0'}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" style={{ padding: "20px", textAlign: "center" }}>
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div style={{ border: "1px solid #dddddd", minHeight: "80px", marginTop: "10px" }}>
              <div
                style={{
                  width: "55%",
                  float: "left",
                  borderRight: "1px solid #dddddd",
                  minHeight: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <center>
                  <b>Authorized Signature</b>
                </center>
              </div>
              <div style={{ width: "45%", float: "right", minHeight: "80px" }}>
                <div style={{ width: "65%", float: "left" }}>
                  <p
                    style={{
                      margin: "0",
                      borderBottom: "1px solid #dddddd",
                      borderRight: "1px solid #dddddd",
                      padding: "0px 5px",
                    }}
                  >
                    Sub Total
                  </p>
                  <p
                    style={{
                      margin: "0",
                      borderBottom: "1px solid #dddddd",
                      borderRight: "1px solid #dddddd",
                      padding: "0px 5px",
                    }}
                  >
                    Discount
                  </p>
                  <b>
                    {" "}
                    <p
                      style={{
                        margin: "0",
                        borderRight: "1px solid #dddddd",
                        padding: "0px 5px",
                      }}
                    >
                      Grand Total
                    </p>
                  </b>
                </div>
                <div style={{ width: "35%", float: "right" }}>
                  <p
                    style={{
                      margin: "0",
                      borderBottom: "1px solid #dddddd",
                      padding: "0px 5px",
                    }}
                  >
                    &#8377;{subTotal}/-
                  </p>
                  <p
                    style={{
                      margin: "0",
                      borderBottom: "1px solid #dddddd",
                      padding: "0px 5px",
                    }}
                  >
                    &#8377;{discount || '0'}/-
                  </p>
                  <b>
                    {" "}
                    <p style={{ margin: "0", padding: "0px 5px" }}>
                      &#8377;{grandTotal || '0'}/-
                    </p>
                  </b>
                </div>
              </div>
            </div>
            <b>
              {" "}
              <p style={{ padding: "10px 5px" }}>
                Total Amount In Word :  {isNaN(parsedGrandTotal) ? "Invalid amount" : converter.toWords(parsedGrandTotal)}  rupees only{" "}
              </p>
            </b>

            {/* <table className="tables">
        <tbody>
          <tr style={{ border: "1px solid #dddddd" }}>
            <td style={{ width: "55%", borderRight: "1px solid #dddddd" }}>
              <h4 className="text-right">Total Amount</h4>
            </td>
            <tr style={{ width: "45%" }}>
             <td> Total : {total}/-</td>
             <td>Discount : {discount}/-</td>
             <td>Grand Total : {grandTotal}/- </td>
            </tr>
          </tr>
        </tbody>
      </table> */}
          </div>
        </div>
      </section>

    </>
  )
}
